import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Branding from './branding-model'
import {
  CreateBrandingAsync,
  DeleteBrandingAsync,
  LoadBrandingsAsync,
} from './branding-thunk'
const initialState: brandingSliceState = {
  branding: [],
  selected_branding: '',
  is_loading_branding: false,
  is_creating_branding: false,
  is_deleting_branding: false,
}
export interface brandingSliceState {
  branding: Branding[]
  selected_branding?: string
  is_loading_branding: boolean
  is_creating_branding: boolean
  is_deleting_branding: boolean
}
export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {
    setSelectedbranding: (state, action) => {
      state.selected_branding = action.payload
    },
    clearStatebranding: (state) => {
      state.branding = []
      state.is_loading_branding = false
      state.is_creating_branding = false
      state.is_deleting_branding = false
    },
    mergebranding: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_branding = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.branding = merge(state.branding, payload) as any
        }
      }
    },

    add_branding: (state, action) => {
      if (action.payload) {
        state.branding = [...state.branding, action.payload]
      }
    },
    set_branding: (state, action) => {
      let { key, value, id } = action.payload
      state.branding = state.branding.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadBrandingsAsync.pending, (state) => {
      state.is_loading_branding = true
    })
    builder.addCase(LoadBrandingsAsync.fulfilled, (state, action) => {
      state.is_loading_branding = false
      if (action.payload) {
        state.branding = action.payload
      }
    })
    builder.addCase(LoadBrandingsAsync.rejected, (state) => {
      state.is_loading_branding = false
    })
    builder.addCase(CreateBrandingAsync.pending, (state) => {
      state.is_creating_branding = true
    })
    builder.addCase(CreateBrandingAsync.fulfilled, (state) => {
      state.is_creating_branding = false
    })
    builder.addCase(CreateBrandingAsync.rejected, (state) => {
      state.is_creating_branding = false
    })
    builder.addCase(DeleteBrandingAsync.pending, (state) => {
      state.is_deleting_branding = true
    })
    builder.addCase(DeleteBrandingAsync.fulfilled, (state, action) => {
      state.is_deleting_branding = false
      if (state.branding) {
        state.branding = state.branding.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteBrandingAsync.rejected, (state) => {
      state.is_deleting_branding = false
    })
  },
})

export const {
  clearStatebranding,
  setSelectedbranding,
  set_branding,
  mergebranding,
  add_branding,
} = brandingSlice.actions

export const get_branding =
  (id?: string) =>
  (state: {
    branding: {
      branding: Branding[]
    }
  }): Branding | null => {
    let temp = state?.branding?.branding?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.branding?.branding[0] || null
  }
export const get_selected_branding = (state: {
  branding: brandingSliceState
}): Branding | null => {
  let id = state?.branding?.selected_branding
  let temp = state?.branding?.branding?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_branding = (state: {
  branding: {
    branding: Branding[]
  }
}): Branding[] => {
  let temp = state?.branding?.branding
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_branding_busy = (state: { branding: brandingSliceState }) => {
  return (
    state?.branding.is_deleting_branding ||
    state?.branding.is_loading_branding ||
    state?.branding.is_creating_branding
  )
}
export const is_deleting_branding_busy = (state: {
  branding: brandingSliceState
}) => {
  return state?.branding.is_deleting_branding
}
export const is_loading_branding_busy = (state: {
  branding: brandingSliceState
}) => {
  return state?.branding.is_loading_branding
}
export const is_creating_branding_busy = (state: {
  branding: brandingSliceState
}) => {
  return state?.branding.is_creating_branding
}

export default brandingSlice.reducer
